import { cn } from "../../lib/utils"

interface MareczekAvatarProps {
	size?: number
	showBadge?: boolean
	className?: string
	/** Overrides the computed badge font size. Use to keep the AI pill the
	 * same visual size while the M circle scales. */
	badgeFontSize?: number
}

export function MareczekAvatar({
	size = 40,
	showBadge = true,
	className,
	badgeFontSize,
}: MareczekAvatarProps) {
	const fontSize = Math.round(size * 0.45)
	const badgeFont = badgeFontSize ?? Math.max(8, Math.round(size * 0.18))
	return (
		<span
			className={cn(
				"relative inline-flex items-center justify-center",
				className,
			)}
			style={{ width: size, height: size }}
		>
			<span
				className="rounded-full bg-primary text-primary-foreground font-bold flex items-center justify-center"
				style={{
					width: size,
					height: size,
					fontSize,
				}}
			>
				M
			</span>
			{showBadge && (
				<span
					className="absolute rounded-full bg-emerald-500 text-white font-bold border-2 border-white"
					style={{
						bottom: -2,
						right: -4,
						fontSize: badgeFont,
						padding: "1px 5px",
						lineHeight: 1.1,
					}}
				>
					AI
				</span>
			)}
		</span>
	)
}
